import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit} from "@angular/core";
import {ChatService} from "../../services/chat.service";
import {Client as ConversationsClient, Conversation} from "@twilio/conversations";
import {Subscription} from "rxjs";
import {BringozChatConversationModel} from "../../models/chat-conversation.model";
import {ChatHttpService} from "../../services/chat-http.service";
import {CurrentSiteContextService} from "../../../commons/angular/services/current-site-context.service";
import {ChatConversationContextType} from "../../types/chat-conversation-context.type";

require('./chat-conversation-service-view.scss');
@Component({
  standalone: false,
  selector: 'chat-conversation-service-view',
  templateUrl: './chat-conversation-service-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatConversationServiceViewComponent implements OnInit, OnDestroy {

  @Input() serviceId: string;

  private siteId: string;
  private conversationsClientSubscription: Subscription;
  public conversationsClient: ConversationsClient;
  public conversation: Conversation;
  private chatConversationContextTypes: typeof ChatConversationContextType = ChatConversationContextType;

  constructor(
    @Inject(ChatService) private chatService: ChatService,
    @Inject(ChatHttpService) private chatHttpService: ChatHttpService,
    @Inject(CurrentSiteContextService) private currentSiteContextService: CurrentSiteContextService,
    @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef
  ) {

  }

  ngOnInit(): void {
    this.siteId = this.currentSiteContextService.currentSiteId;
    this.conversationsClientSubscription = this.chatService.conversationsClient
      .subscribe((conversationsClient: ConversationsClient) => {
        this.conversationsClient = conversationsClient;
        this._startConversation()
      });
  }

  ngOnDestroy(): void {
    this.conversationsClientSubscription.unsubscribe();
  }

  // private _initConversationsEvents() {
  //   if (this.conversationsClient) {
  //
  //     // this.conversationsClient.on("connectionStateChanged", (state: ConnectionState) => {
  //     //   if (state === "connecting") {
  //     //   }
  //     //   if (state === "connected") {
  //     //   }
  //     //   if (state === "disconnecting") {
  //     //   }
  //     //   if (state === "disconnected") {
  //     //   }
  //     //   if (state === "denied") {
  //     //   }
  //     // });
  //
  //     this.conversationsClient.on("initialized", () => {
  //       this.initialized = true;
  //       this.currentUserIdentity = this.conversationsClient.user.identity;
  //     });
  //   }
  // };


  private _startConversation() {
    const chatConversation: BringozChatConversationModel = {
      id: this.serviceId,
      contextEntityId: this.serviceId,
      contextType: this.chatConversationContextTypes.Service
    };
    this.chatHttpService.createConversation(this.siteId, chatConversation)
      .subscribe((c: BringozChatConversationModel) => {
        this.conversationsClient.getConversationByUniqueName(c.externalId)
          .then((conversation: Conversation) => {
            this.conversation = conversation;
            this.cdr.detectChanges();
          })
      })
  }

}
